export enum UserManagerView {
    Users = 'users',
    Info = 'info'
}
